import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/cadd";
import { types as authTypes } from "../reducers/authentication";
import { CaddService, ProjectService } from "../../services";
import ErrorFormat from '../../helpers/FormatErrors';

function* submitAdditionalInformation({ value }) {
  try {
    const {
      data: user,
    } = yield call(() => CaddService.submitAdditionalInformation({ ...value, module: 'cadd' }));
    if (user) {
      yield put({ type: types.ADDITIONAL_INFORMATION_SUCCEDDED, value: user });
      yield put({ type: authTypes.AUTHENTICATION_SUCCEDDED, value: user });
    }
  } catch (e) {
    const {
      response: {
        data: { errors },
      },
    } = e;
    if (errors.length > 0) {
      const formattedErrors = {};
      const getProperty = (childrens, errs = {}) => {
        childrens.forEach(ch => {
          if (ch.constraints) {
            return Object.assign(errs, {
              [ch.property]: Object.values(ch.constraints),
            });
          } else if (ch.children) {
            errs[ch.property] = getProperty(ch.children);
            return errs;
          }
        });
        return errs;
      }
      errors.forEach((error) => {
        if (error.constraints) {
          Object.assign(formattedErrors, {
            [error.property]: Object.values(error.constraints),
          });
        } else if (error.children) {
          formattedErrors[error.property] = Object.values(getProperty(error.children));
        }
      });
      yield put({
        type: types.ADDITIONAL_INFORMATION_FAILED,
        value: formattedErrors,
      });
      return;
    }
  }
}

// function* getProjects() {
//   try {
//     const { data } = yield call(() => ProjectService.get());
//     if (data) {
//       yield put({ type: types.GET_PROJECTS_SUCCEDDED, value: data.length === 0 ? [] : data });
//     }
//   } catch (e) {
//     const errors = ErrorFormat.format(e.response.data.errors);
//     if (errors) {
//       yield put({
//         type: types.GET_PROJECTS_FAILED,
//         value: errors,
//       });
//     }
//   }
// }

// function* getProject({ value }) {
//   try {
//     const { data } = yield call(() => ProjectService.getById(value));
//     if (data) {
//       yield put({
//         type: types.GET_PROJECT_SUCCEDDED,
//         value: data,
//       });
//     }
//   } catch (e) {
//     const errors = ErrorFormat.format(e.response.data.errors);
//     if (errors) {
//       yield put({
//         type: types.GET_PROJECT_FAILED,
//         value: errors,
//       });
//     }
//   }
// }

function* createProject({ value }) {
  try {
    const { data } = yield call(() => ProjectService.create(value));
    if (data) {
      yield put({ type: types.NEW_PROJECT_SUCCEDDED, value: [] });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.NEW_PROJECT_FAILED,
        value: errors,
      });
    }
  }
}

function* updateProjectStatus({ value }) {
  try {
    const { data } = yield call(() => ProjectService.updateStatus(value.id, value.status));
    if (data) {
      yield put({ type: types.UPDATE_PROJECT_STATUS_SUCCEDDED, value: data });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.UPDATE_PROJECT_STATUS_FAILED,
        value: errors,
      });
    }
  }
}

export default function* init() {
  yield takeEvery(
    types.ADDITIONAL_INFORMATION_REQUESTED,
    submitAdditionalInformation
  );
  // yield takeEvery(
  //   types.GET_PROJECTS_REQUESTED,
  //   getProjects,
  // );
  // yield takeEvery(
  //   types.GET_PROJECT_REQUESTED,
  //   getProject,
  // );
  yield takeEvery(
    types.NEW_PROJECT,
    createProject
  );
  yield takeEvery(
    types.UPDATE_PROJECT_STATUS_REQUESTED,
    updateProjectStatus,
  );
}
